import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-navy text-center text-cream" aria-label="Offerta a tempo limitato" data-id="element-203" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-gold" aria-hidden="true" data-id="element-204" data-mp="36biovp3q1vh1" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-205" data-mp="31ipikwsluf2u">
        <p className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[.16em] text-gold" data-id="element-206" data-mp="31h4ot9e47061">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-207" data-mp="3g9yfzs2r14qj" /> Il prezzo di lancio termina tra
        </p>
        <Countdown className="mt-5" data-id="element-208" data-mp="3p8tjuxibm2qo" />
        <p className="mt-7 font-bold text-haze" data-id="element-209" data-mp="3p7sbj0sovucn">Dopo, il prezzo aumenta e non tornerà più così basso.</p>
      </div>
      <div className="h-1 w-full bg-gold" aria-hidden="true" data-id="element-210" data-mp="3l7q8an7b2sv9" />
    </section>;
}